import { Box, Button, Icon, Text } from '@factorialco/deprecated-design-system'

import Loading from 'modules/core/components/Loading'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

interface EmptyBodyProps {
  isLoading: boolean
}

const UpdatesActivation = ({ isLoading }: EmptyBodyProps) => {
  const { navigation } = useNavigation()
  const navigateToUpdateActivation = () => {
    track(trackingEvents.payroll.userClicksOnGoToUpdates)
    return navigation.payrollBundle.inhouseActivation.fullPath()
  }

  if (isLoading) return <Loading />

  return (
    <Box gap="s8" style={{ flex: '1' }}>
      <Box gap="s12" flexDirection="row" justifyContent="spaceBetween">
        <Text.Header2>{i18n.t('updates.title')}</Text.Header2>
      </Box>
      <Box
        width="full"
        height="s200"
        justifyContent="center"
        alignItems="center"
        gap="s24"
        border={{ all: { color: 'grey400', width: 's1', style: 'solid' } }}
        borderRadius={{ all: 'abs008' }}
        padding="s16"
        flexGrow
      >
        <Box alignItems="center" gap="s6">
          <Icon.Large icon="user-male-female" color="grey800" />

          <Text.Normal size="300" color="grey800">
            {i18n.t('updates.track_employee_updates')}
          </Text.Normal>
        </Box>
        <Button.Router type="primary" to={navigateToUpdateActivation()}>
          {i18n.t('updates.button')}
        </Button.Router>
      </Box>
    </Box>
  )
}

export default UpdatesActivation
